function detectBrowser() {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Firefox')) {
    return 'Firefox';
  }
  else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    return 'Chrome';
  }
  else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari';
  }
  else if (userAgent.includes('Edg')) {
    return 'Microsoft Edge';
  }
  else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  }
  else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    return 'Internet Explorer';
  }
  else {
    return 'Неизвестный браузер';
  }
}

function detectPlatform() {
  return navigator.platform;
}

export function getInterpretedUA() {
  return `${detectBrowser()} (${detectPlatform()})`;
}
